/** 
*@author: satyamurthy.a
*@Description : 
**/
import axios from 'axios';
import React, { useEffect, useRef, useState } from 'react';
import { Select, message, Button, Form } from 'antd';
import localStorage from '../../../utils/localStorage';
import { GETUSERLIST, CUSTOM_REPORT } from '../../../commons/api';
import themeSettings from '../../Modules/DataBackup/Utils/themeSettings.json';

const { Option } = Select;

const DailyReportUsers = (props) => {
  // const [dataSource, setDataSource] = useState([]);
  const [userList, setUserList] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const  [ modalVisible,setModalVisible] = useState(false);
  const href = useRef(null);

  useEffect(() => {
    const fetchData = async () => {
      const userList = await getUsersList();
      const response = await getTableData();
      let selectedUsers = [];

      if (response) {
        selectedUsers = response.map((resp) => resp.Id);
      }

      if (href.current) {
        href.current.setFieldsValue({ Users: selectedUsers });
      }

      setUserList(userList);
      setSelectedUsers(selectedUsers);
    };

    fetchData();
  }, []);

  const getTableData = async () => {
    let siteId = localStorage.get('currentSite') || 'test';
    const accessToken = localStorage.get('accessToken');
    
    const Headers = {
      method: 'GET',
      url: `${CUSTOM_REPORT.RecipientsList}?SiteId=${siteId}`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    };

    try {
      const response = await axios(Headers);
      return response.data;
    } catch (error) {
      console.log(error);
    }
  };

  const getUsersList = async () => {
    const token = localStorage.get('accessToken');
    const siteId = localStorage.get('currentSite');
    
    const data = {
      url: `${GETUSERLIST.GET}?SiteId=${siteId}`,
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    };

    try {
      const response = await axios(data);
      return response.data;
    } catch (error) {
      message.error(
        `${error?.response?.data?.message}`
      );
    }
  };

  const CreateUser  = async () => {
    const siteId = localStorage.get('currentSite');
    const token = localStorage.get('accessToken');
    
    const getReportData = {
      method: 'POST',
      url: `${CUSTOM_REPORT.CreateRecipients}?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${token}`
      },
      data: {
        SiteId: siteId,
        UserId: selectedUsers
      }
    };

    try {
      const response = await axios(getReportData);
      return response;
    } catch (error) {
      if (error?.response?.status === 400) {
        message.info(error?.response?.data?.message);
      }
    }
  };

  const onModalok = async () => {
    const response = await CreateUser ();
    if (response?.status === 200) {
      message.success(response?.data?.message);
    }
    await getTableData();
    
    if (href.current) {
      href.current.setFieldsValue({ Users: selectedUsers });
    }
    
    setModalVisible(false);
  };

  const onModalCancel = () => {
    modalVisible(false);
  };

  const userOnchange = (value) => {
    setSelectedUsers(value);
  };

  const translation = (keyword) => {
    const { translationCache } = props;
    return translationCache?.[keyword] || keyword;
  };

  return (
    <div>
      <Form 
        name="user_form"
        autoComplete="off"
        ref={href}
        onFinish={onModalok}
        onClose = {onModalCancel}
        theme={themeSettings}
        layout="horizontal"
        labelCol={{ flex: '200px' }}
        labelAlign="right"
        labelWrap
        wrapperCol={{ flex: 1 }}
      >
        <Form.Item name={'Users'} style={{ width: '100%', flex: '50%' }} label={translation('Users')}>
          <Select
            style={{ width: '400px' }}
            mode="multiple"
            showArrow
            value={selectedUsers}
            placeholder={translation('Please Select Users')}
            onChange={userOnchange}
          >
            {userList.map ((user, index) => (
              <Option key={index} value={user.Id}>
                {user.Email}
              </Option>
            ))}
          </Select>
        </Form.Item>
        <div style={{ marginLeft: '600px', marginTop: '40px' }}>
          <Button type="primary" htmlType="submit">
            {translation('Submit')}
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default DailyReportUsers;